import { RTM } from "@/qrtc_web_rtm/rtm";
import { RTMConfig } from "@/qrtc_web_rtm/rtmTypes";
import * as consts from "@/config/const";
import { storage } from "@/util";
import { useEffect, useState } from 'react';

//let rtmInstance: RTM = undefined;

interface RtmConstProp {
  appId?: string;
  userId?: string;
  rtmConfig?: RTMConfig;
}

const artmConfig = {
  serverUrl: consts.RTM_SERVERURL, //should add serverUrl in RTMConfig this is differ from agora
  token: consts.RTM_TOKEN,
  encryptionMode: "chacha20",
  cipherKey: "string",
  salt: new Uint8Array(6),
  useStringUserId: true,
  presenceTimeout: 1000,
  logUpload: false,
  logLevel: "verbose",
  cloudProxy: false,
};

const loginAndChannel = async (inst: RTM) => {
  console.log("loginAndChannel!!! start");
  await inst.login();
  await inst.subscribe("notification");
};
/*这个 useRtm 钩子函数的主要目的是创建并返回一个 RTM 实例。以下是我对这个函数可能存在的一些缺陷的分析：

全局状态：这个函数依赖于一个全局变量 rtmInstance。这可能会导致状态管理变得复杂，特别是在并发环境中。

副作用：这个函数在创建 RTM 实例后立即调用了 loginAndChannel 函数。这可能是一个副作用，应该在 useEffect 钩子中处理。

错误处理：如果 userId 不存在，这个函数只是打印一条消息然后返回 null。这可能会导致调用者在处理返回值时出错。更好的做法是抛出一个错误，或者返回一个表示错误状态的对象。

依赖注入：这个函数依赖于 RTM 类和 loginAndChannel 函数。如果你想测试这个函数，你可能需要使用依赖注入来提供这些依赖，而不是直接在函数中使用它们。

React 钩子规则：虽然这个函数的名字以 use 开头，但它并没有使用任何 React 钩子。根据 React 的规则，只有使用了 React 钩子的函数才应该以 use 开头。如果这个函数没有使用 React 钩子，它可能不应该被称为一个钩子函数。


*/
/*

*/
type EventHandler = (data: string) => void;
let rtmInstance: RTM | null = null;

const useRtm= (p: RtmConstProp, onClosedByServer:EventHandler) => {

  useEffect(() => {
    // 添加事件监听
    rtmInstance?.on('closedByServer', onClosedByServer);

    // 组件卸载时，移除监听器
    return () => {
      //rtmInstance?.off('closedByServer', onClosedByServer);
    };
  }, [onClosedByServer]);
  
  if (rtmInstance) return rtmInstance;
  const logInfo = storage.get(consts.LOGININFOSTORE) ?? {};
  const {
    appId = consts.RTM_APPID,
    userId = logInfo.userId,
    rtmConfig = artmConfig,
  } = p ?? {};
  if (!userId) {
    //console.log("not logined ...");
    return null;
  }
  const inst = new RTM(appId, userId, rtmConfig);
 
  loginAndChannel(inst);
  rtmInstance = inst;


  return rtmInstance;
};

// let myuserId:any= null;
// const useRtm = (p?: RtmConstProp) => {
//   const [instance, setInstance] = useState(null);

//   useEffect(() => {
    
//     const logInfo = storage.get(consts.LOGININFOSTORE) ?? {};
//     const {
//       appId = consts.RTM_APPID,
//       userId = logInfo.userId,
//       rtmConfig = artmConfig,
//     } = p ?? {};
//     if (!userId) {
//       console.log("not logined ...");
//       return;
//     }
//     myuserId=userId;
//     if (rtmInstance) {
//       setInstance(rtmInstance);
//       return;
//     }
//     const inst = new RTM(appId, userId, rtmConfig);
//     loginAndChannel(inst);
//     rtmInstance = inst;
//     setInstance(inst);
//   }, [p]);

//   return instance;
// };
export default useRtm;
